"use client";

const PROJECT_ID = "wa3ii5pg52";
const MAX_EVENT_NAME_LENGTH = 255;

interface ClarityWindow extends Window {
  clarity?: { (...args: unknown[]): void; q?: unknown[] };
}

let loaded = false;
const pendingEvents: string[] = [];

function getClarityWindow(): ClarityWindow | null {
  if (typeof window === "undefined") return null;
  return window as ClarityWindow;
}

function installClarityStub(w: ClarityWindow) {
  w.clarity = w.clarity || function (...args: unknown[]) {
    (w.clarity!.q = w.clarity!.q || []).push(args);
  };
}

function injectClarityScript() {
  if (document.getElementById("microsoft-clarity-sdk")) return;
  const script = document.createElement("script");
  script.id = "microsoft-clarity-sdk";
  script.async = true;
  script.src = `https://www.clarity.ms/tag/${PROJECT_ID}`;
  const firstScript = document.getElementsByTagName("script")[0];
  firstScript.parentNode?.insertBefore(script, firstScript);
}

function normalizeEventName(name: string): string {
  return name.slice(0, MAX_EVENT_NAME_LENGTH);
}

function drainPendingEvents(w: ClarityWindow) {
  if (!w.clarity) return;
  while (pendingEvents.length > 0) {
    const eventName = pendingEvents.shift();
    if (eventName) w.clarity("event", eventName);
  }
}

export function ensureClarity(): boolean {
  const w = getClarityWindow();
  if (!w) return false;

  installClarityStub(w);
  injectClarityScript();
  loaded = true;
  drainPendingEvents(w);
  return true;
}

export function captureClarityEvent(name: string): void {
  const eventName = normalizeEventName(name);
  const w = getClarityWindow();
  if (!w) return;

  if (!loaded || !w.clarity) {
    pendingEvents.push(eventName);
    return;
  }

  try {
    w.clarity("event", eventName);
  } catch {
    // Clarity is best-effort UX telemetry; never throw into UI handlers.
  }
}
